import { render, staticRenderFns } from "./TicketMessageView.vue?vue&type=template&id=15cd66eb"
import script from "./TicketMessageView.vue?vue&type=script&lang=js"
export * from "./TicketMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports